/** Card-only Payment Element — wallets are not implemented or tested end-to-end. */
export const CARD_ONLY_PAYMENT_ELEMENT_OPTIONS = {
    wallets: {
        applePay: 'never',
        googlePay: 'never',
        link: 'never',
    },
};
